/***
 * 文件服务：文件的上传与下载
 */
import axios from 'axios'

/**
 * 上传文件
 * @param fileName 文件名
 * @param file 文件对象
 * @param targetId 文件归属组织(选填)
 * @returns {*}
 */
async function upload({fileName, file, targetId, onUploadProgress, cancelToken}) {
  // const hash = await readFileHash(file)
  // const fileInfo = {'fileName': fileName, 'fileHash': hash}
  const fileInfo = {'fileName': fileName, 'fileHash': '1111'}
  return new Promise((resolve, reject) => {
    const formData = new window.FormData()
    if (targetId) {
      fileInfo.targetId = targetId
    }
    formData.append('file', file)
    formData.append('ct', JSON.stringify(fileInfo))
    axios({
      method: 'post',
      url: SERVERCONFIG.VUE_APP_BASE_API + '/fjxhx/file/server/api/file/no/hash',
      responseType: 'json',
      data: formData,
      cancelToken,
      onUploadProgress: onUploadProgress
    }).then(response => {
      if (/ERR_/.test(response.data)) {
        const errorJson = JSON.parse(response.data.substr(4))
        reject(errorJson)
      } else {
        resolve(response.data)
      }
    }).catch(e => {
      reject(e)
    })
  })
}

export {upload}



// WEBPACK FOOTER //
// ./src/utils/fileServer.js